import classNames from 'classnames';
import type { CSSProperties } from 'styled-components';

import { getBackgroundColorStyle } from '../utils/background';

import * as styles from './Navbar.css';
import type { NavbarMenuDropdownElementProps } from './Navbar.type';
import {
  NAVBAR_MENU_DROPDOWN_CARD_DEFAULTS,
  NAVBAR_MENU_DROPDOWN_FULL_DEFAULTS,
  NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS,
} from './NavbarMenuDropdown.constants';
import { useDropdownContext } from './useDropdownContext';

export function NavbarMenuDropdown(
  props: NavbarMenuDropdownElementProps & {
    controlbyselected: boolean | string;
    screen: 'desktop' | 'mobile';
  },
) {
  const { element, screen, className, children, controlbyselected: controlbyselectedProp } = props;
  let controlbyselected = controlbyselectedProp;
  if (typeof controlbyselected === 'string') {
    controlbyselected = controlbyselected === 'true';
  }
  const { style, padding, background, border_radius, customAttributes } = element.attrs || {};

  const { open, setDropdownSelected } = useDropdownContext();
  const DEFAULTS = style === 'card' ? NAVBAR_MENU_DROPDOWN_CARD_DEFAULTS : NAVBAR_MENU_DROPDOWN_FULL_DEFAULTS;

  if (screen === 'mobile' && !element.attrs?.parentInMobile) {
    return (
      // biome-ignore lint/a11y/useValidAriaRole: <explanation>
      <div
        {...props}
        role="none"
        {...customAttributes}
        className={classNames(styles.navbarMobileDropdown, className, customAttributes?.className)}
        style={
          {
            '--padding': padding ?? NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS.padding,
            '--gap': NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS.gap,
            ...getBackgroundColorStyle(background ?? NAVBAR_MENU_DROPDOWN_MOBILE_DEFAULTS.background),
            pointerEvents: open ? 'auto' : 'none',
          } as CSSProperties
        }
      >
        {children}
      </div>
    );
  }

  return (
    // biome-ignore lint/a11y/useValidAriaRole: <explanation>
    <div
      {...props}
      role="none"
      {...customAttributes}
      className={classNames(styles.navbarDropdown, className, customAttributes?.className)}
      onMouseEnter={
        controlbyselected
          ? () => {}
          : () => {
              setDropdownSelected(true);
            }
      }
      onMouseLeave={
        controlbyselected
          ? () => {}
          : () => {
              setDropdownSelected(false);
            }
      }
      style={
        {
          '--padding': padding ?? DEFAULTS.padding,
          '--border-radius': border_radius ?? DEFAULTS.borderRadius,
          '--width': DEFAULTS.width,
          ...getBackgroundColorStyle(background ?? DEFAULTS.background),
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
